import { BackHandler, Keyboard, KeyboardAvoidingView, Platform, useWindowDimensions, } from 'react-native'
import React, { useEffect, useState } from 'react'
import { DeviceEventEmitter } from 'react-native'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { ThemeConsumer } from '@rneui/themed'
import { config } from '../../../shared/environment'
import Popover from 'react-native-popover-view'

import { ParentCategoryRes, SaveCategory, } from '../categoryModule'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { useAppRoute } from '../../../types/@react-navigation/navigation'
import { useAppNavigation } from '../../../types/@react-navigation/navigation'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { addPosCategory, getOnePosCategories, getPosParentCategory, updatePosCategory } from '../../../redux/slices/categorySlice'
import { CategoryFormValues } from '../categoryModule';

import CommonHeader from '../../../shared/commonComponents/commonHeader'
import { CustomModal } from '../../../shared/commonComponents/customModal'
import CommonDialogBox from '../../../shared/commonComponents/commonDialogBox'
import { appColors } from '../../../themes/appTheme'

import { ZenButton, ZenLoader, ZenToast } from 'zen-core-elements'

import Product from './product'
import Category from './category'

const AddEditCategories = () => {
    const navigation = useAppNavigation()
    const { width } = useWindowDimensions()
    const TopTab = createMaterialTopTabNavigator()
    const { params: { categoryId, isView, productCount } = {} as { categoryId: number, isView: boolean, productCount?: number } } = useAppRoute('AddEditCategories') as { params?: { categoryId: number, isView: boolean, productCount?: number } }
    const [parentCategory, setParentCategory] = useState<any>([])
    const isAddLoading = useAppSelector((state) => state?.category?.addEditCategoryLoader)
    const [isLoading, setIsLoading] = useState(true)
    const [dupError, SetDupError] = useState(false)
    const [leavePopoverVisible, setLeavePopoverVisible] = useState<boolean>(false)
    const dispatch = useAppDispatch()
    const leaveDialogProps = {
        content: 'Are you sure you want to leave this page? ',
        button: [{ id: 1, name: 'Stay', color: appColors.primary, backgroundColor: appColors.light }, { id: 2, name: 'Leave Page', color: appColors.light, backgroundColor: appColors.primary }],
        icon: { name: 'run', color: appColors.primary, type: 'material-community' }
    }
    const YupValidation = Yup?.object()?.shape({
        categoryName: Yup.string()
            .required("Category name is required*")
    })

    useEffect(() => {
        if (categoryId) {
            getOnePosCategory()
        }
        else
            getParentCategory()
    }, [])

    useEffect(() => {
        const duplicateError = DeviceEventEmitter.addListener("Duplicate", (Event) => {
            SetDupError(Event)
        })
        return (() => {
            duplicateError?.remove()
        })
    }, [])


    // Method which is used for leave confirmation
    const confirmation = (value: { name: String }) => {
        if (value?.name == 'Stay') {
            setLeavePopoverVisible(false)
        }
        else {
            setLeavePopoverVisible(false)
            navigation.goBack()
        }
    }

    const getOnePosCategory = (isGetOnly?: boolean) => {
        dispatch(getOnePosCategories({ storeId: config?.storeId, id: categoryId }))
            .unwrap()
            .then((response) => {
                if (response?.categoryDetails) {
                    const categoryDetails = response.categoryDetails;
                    formik.resetForm({
                        values: {
                            categoryId: categoryDetails?.id ?? -1,
                            categoryName: categoryDetails?.categoryname ?? "",
                            parentCategory: categoryDetails?.parentcategoryid ?? null,
                            isPos: categoryDetails?.ispos ?? true,
                            mainImage: categoryDetails?.categoryImageUrl
                        }
                    });
                }
                if (!isGetOnly)
                    getParentCategory();
            })
            .catch((err) => {
                console.log('Error in getOneCategory', err);
            });
    };

    const getParentCategory = () => {
        dispatch(getPosParentCategory({ storeId: config?.storeId })).unwrap().then((parentCategoryResponse) => {
            let parentCategoryArr: any = []
            if (parentCategoryResponse && parentCategoryResponse?.parentCategory) {
                parentCategoryResponse?.parentCategory?.forEach((category: ParentCategoryRes, index: number) => {
                    if (category) {
                        parentCategoryArr.push({ label: category?.categoryName, value: category?.id })
                    }
                });
                setParentCategory(parentCategoryArr)
            }
        }).catch((err) => { console.log('Error in getParentCategory', err) })
            .finally(() => { setIsLoading(false) })
    }

    const formik = useFormik<CategoryFormValues>({
        initialValues: {
            categoryId: -1,
            categoryName: "",
            parentCategory: -1,
            isPos: true,
            mainImage: null
        },
        validationSchema: YupValidation,
        onSubmit: (values) => {
            if (!dupError)
                addEditCategoryProducts(values)
            else
                ZenToast({ type: 'warning', message: 'Please enter the unique category name' })
        },
    });

    useEffect(() => {
        const backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
            if (formik?.dirty) {
                setLeavePopoverVisible(true)
                return true
            }
            else {
                navigation.goBack()
            }
            return true
        });
        return () => backHandler?.remove()
    }, [formik?.values])

    useEffect(() => {
        const CategoryProductsApi = DeviceEventEmitter.addListener("CategoryProductsApi", (productIds: number[]) => {
            addEditCategoryProducts(formik?.values, productIds, true)
        })
        return () => {
            CategoryProductsApi?.remove()
        }
    }, [formik])



    const addEditCategoryProducts = (values: CategoryFormValues, selectedProducts?: number[], isevent?: boolean) => {
        const data = {
            name: values?.categoryName,
            parentCategoryId: values?.parentCategory !== -1 ? values?.parentCategory : null,
            selectedProducts: selectedProducts || [],
            isPos: values?.isPos,
            medium: "POS",
            imageGallery: formik?.values?.mainImage
        }
        const inputData = { details: data, type: false }
        if (categoryId > 0) { updateCategory(inputData, categoryId, true) }
        else {
            addCategory(inputData, true)
        }
    }

    const addCategory = (data: SaveCategory, isevent: boolean) => {
        dispatch(addPosCategory({ storeId: config?.storeId, data })).unwrap().then((response) => {
            if (response?.createDetails[0]?.isPlanExceedLimit == true) {
                formik?.resetForm();
                ZenToast({ type: "warning", message: response?.message })
            }
            else if (response?.createDetails?.length) {
                formik?.resetForm();
                ZenToast({ type: 'success', message: 'Category created successfully' });
            }
        }).catch((err) => {
            console.log('Error in addCategory', err);
            ZenToast({ type: 'error', message: 'Failed to add category' })
        }).finally(() => {
            navigation.pop(isevent ? 2 : 1)
        })
    }

    const updateCategory = (data: SaveCategory, categoryId: number, isevent: boolean) => {
        dispatch(updatePosCategory({ storeId: config?.storeId, editId: categoryId, data: data })).unwrap().then((response) => {
            if (response) {
                ZenToast({ type: 'success', message: 'Category updated successfully' });
            }
        }).catch((err) => {
            console.log('Error in update category', err);
            ZenToast({ type: 'error', message: 'Failed to update category' })
        }).finally(() => {
            navigation.pop(isevent ? 2 : 1)
        })
    }


    return (
        <ThemeConsumer>
            {({ theme }) => (
                <KeyboardAvoidingView behavior={Platform.OS === "ios" ? "padding" : undefined} onStartShouldSetResponder={() => { Keyboard?.dismiss(); return false }} enabled style={theme?.addEditCustomerStyle?.outerContainer} >
                    <CommonHeader headerName={!categoryId ? "Add Category" : isView ? "View Category" : "Edit Category"} backIcon backIconOnpress={() => { formik?.dirty ? setLeavePopoverVisible(true) : navigation?.goBack() }}
                        rightComponent=
                        {!isView ?
                            <ZenButton
                                title={categoryId ? "Update" : "Save"}
                                disabled={!formik?.dirty}
                                titleColor={theme?.light}
                                titleStyle={{ fontSize: theme.errorFontSize, fontFamily: theme.bold }}
                                buttonStyle={{ backgroundColor: theme?.primary, borderRadius: 10, padding: 1 }}
                                onPress={() => { formik.handleSubmit() }}
                            /> : <></>
                        }
                    />
                    {isLoading ?
                        <ZenLoader viewStyle={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "transparent" }} color={theme.primary} lottieType="Local" lottie={require('../../../assets/infinityLoader.json')} />
                        :
                        <TopTab.Navigator
                            initialRouteName="Category"
                            screenOptions={{
                                lazy: true,
                                tabBarLabelStyle: { fontSize: theme.largerFontSize, fontFamily: theme.bold, textTransform: 'capitalize' },
                                tabBarIndicatorStyle: { backgroundColor: theme.primary },
                                tabBarActiveTintColor: theme.primary,
                                tabBarInactiveTintColor: theme.lightFontColor,
                                tabBarAndroidRipple: { borderless: false },
                                swipeEnabled: false
                            }}
                            backBehavior="none"
                        >
                            <TopTab.Screen
                                name="Category"
                                options={{ tabBarLabel: 'Category', title: "Category" }}
                                children={() => <Category formik={formik} parentCategory={parentCategory} isView={isView} />}
                            />
                            <TopTab.Screen
                                name="Products"
                                options={{ tabBarLabel: 'Products', title: "Products" }}
                                component={Product}
                                initialParams={{ categoryId: categoryId, isView, isAllProduct: false, formikValues: formik.values, productCount }}
                                listeners={{
                                    tabPress: (e) => {
                                        if (!formik.values.categoryName?.trim() || dupError) {
                                            e.preventDefault();
                                            ZenToast({ type: "warning", message: "Please enter a category name." });
                                        }
                                    },
                                }}
                            />
                        </TopTab.Navigator>}
                    <CustomModal visible={isAddLoading} transparent>
                        <ZenLoader transparent viewStyle={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "transparent" }} color={theme.primary} lottieType="Local" lottie={require('../../../assets/infinityLoader.json')} />
                    </CustomModal>
                    <Popover isVisible={leavePopoverVisible} popoverStyle={{ width: width > 900 ? 500 : width > 600 ? 450 : 350, borderRadius: 10 }}>
                        <CommonDialogBox type="OTHER" dialog={leaveDialogProps} confirmation={confirmation} />
                    </Popover>
                </KeyboardAvoidingView>
            )}
        </ThemeConsumer>
    )
}

export default AddEditCategories
